// // import React from "react";
// // import { Box, Typography } from "@mui/material";
// // import { makeStyles } from "@mui/styles";

// // const useStyles = makeStyles({
// // 	imgWrap: {
// // 		overflow: "hidden",
// // 		display: "inline-block",
// // 		width: "330px",
// // 		height: "340px",
// // 		"&:hover": { backgroundColor: "black" },
// // 		"&:hover $btn": { display: "block" },
// // 	},
// // 	btn: {
// // 		position: "relative",
// // 		top: "-180px",
// // 		left: "+87px",
// // 		backgroundColor: "#212a2f",
// // 		color: "white",
// // 		letterSpacing: "3px",
// // 		textTransform: "uppercase",
// // 		padding: "20px",
// // 		border: "none",
// // 		display: "none",
// // 		cursor: "pointer",
// // 	},
// // 	img: {
// // 		width: "100%",
// // 		height: "100%",
// // 		transition: "all .2s ease-in-out",
// // 		display: "inline-block",
// // 		"&:hover": {
// // 			transform: "scale(1.1)",
// // 			height: "330px",
// // 		},
// // 	},
// // 	bottom: {
// // 		paddingTop: "10px",
// // 		paddingBottom: "10px",
// // 		borderBottom: "1px solid lightgray",
// // 		width: "90%",
// // 		marginLeft: "auto",
// // 		marginRight: "auto",
// // 		textAlign: "center",
// // 	},
// // 	text: {
// // 		padding: "20px",
// // 		textAlign: "center",
// // 		fontSize: "13px",
// // 		fontWeight: "lighter",
// // 	},
// // });
// // const IndexMiddleHome = () => {
// // 	const classes = useStyles();
// // 	return (
// // 		<Box sx={{ pt: 4, display: "flex", justifyContent: "space-between" }}>
// // 			<Box
// // 				className={classes.box}
// // 				sx={{ position: "relative", overflow: "hidden" }}
// // 			>
// // 				<Box className={classes.imgWrap}>
// // 					<img
// // 						className={classes.img}
// // 						style={{
// // 							backgroundSize: "cover",
// // 							transition: "all .2s ease-in-out",
// // 						}}
// // 						alt=""
// // 						src="https://images.unsplash.com/photo-1570126618953-d437176e8c79?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1094&q=80"
// // 					/>
// // 				</Box>

// // 				<Box className={classes.bottom}>All Purpose Sanitizing</Box>
// // 				<Box className={classes.text}>For wet-weather runs</Box>
// // 			</Box>

// // 			<Box
// // 				className={classes.box}
// // 				sx={{ position: "relative", overflow: "hidden" }}
// // 			>
// // 				<Box className={classes.imgWrap}>
// // 					<img
// // 						className={classes.img}
// // 						style={{
// // 							backgroundSize: "cover",
// // 							transition: "all .2s ease-in-out",
// // 						}}
// // 						width="340"
// // 						height="330"
// // 						alt=""
// // 						src="https://images.unsplash.com/photo-1497215641119-bbe6d71ebaae?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=987&q=80"
// // 					/>
// // 				</Box>

// // 				<Box className={classes.bottom}>All Purpose Sanitizing</Box>
// // 				<Box className={classes.text}>For wet-weather runs</Box>
// // 			</Box>

// // 			<Box
// // 				className={classes.box}
// // 				sx={{ position: "relative", overflow: "hidden" }}
// // 			>
// // 				<Box className={classes.imgWrap}>
// // 					<img
// // 						className={classes.img}
// // 						style={{
// // 							backgroundSize: "cover",
// // 							transition: "all .2s ease-in-out",
// // 						}}
// // 						width="340"
// // 						height="330"
// // 						alt=""
// // 						src="https://images.unsplash.com/photo-1522968941782-e27ac665baa3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=988&q=80"
// // 					/>
// // 				</Box>

// // 				<Box className={classes.bottom}>All Purpose Sanitizing</Box>
// // 				<Box className={classes.text}>For wet-weather runs</Box>
// // 			</Box>
// // 		</Box>
// // 	);
// // };

// // export default IndexMiddleHome;
// import React from "react";
// import { Box, Button } from "@mui/material";
// import { makeStyles } from "@mui/styles";
// import { styled } from "@mui/system";
// import { HashLink } from "react-router-hash-link";
// const Btn = styled(Button)`
// 	position: absolute;
// 	top: 170px;
// 	background-color: white;
// 	color: black;
// 	box-shadow: none;
// 	letter-spacing: 0.3em;
// 	display: none;
// 	&:hover {
// 		background-color: #a9a9a9;
// 	}
// 	&:focus {
// 		background-color: green;
// 	}
// `;
// const Container = styled(Box)`
// 	cursor: pointer;
// 	box-shadow: rgba(0, 0, 0, 0.1) 0px 20px 25px -5px,
// 		rgba(0, 0, 0, 0.04) 0px 10px 10px -5px;
// 	position: relative;
// 	overflow: hidden;
// 	flex-direction: column;
// 	align-items: center;
// 	&:hover {
// 		btn: {
// 		}
// 	}
// `;

// const useStyles = makeStyles({
// 	imgWrap: {
// 		overflow: "hidden",
// 		display: "inline-block",
// 		width: "330px",
// 		height: "340px",
// 		"&:hover": { backgroundColor: "black" },
// 		"&:hover $btn": { display: "block" },
// 	},
// 	btn: {
// 		position: "relative",
// 		top: "-180px",
// 		left: "+87px",
// 		backgroundColor: "#212a2f",
// 		color: "white",
// 		letterSpacing: "3px",
// 		textTransform: "uppercase",
// 		padding: "20px",
// 		border: "none",
// 		display: "none",
// 		cursor: "pointer",
// 	},
// 	img: {
// 		width: "100%",
// 		height: "100%",
// 		transition: "all .2s ease-in-out",
// 		display: "inline-block",
// 		"&:hover": {
// 			transform: "scale(1.1)",
// 			height: "330px",
// 		},
// 	},
// 	bottom: {
// 		paddingTop: "10px",
// 		paddingBottom: "10px",
// 		borderBottom: "1px solid lightgray",
// 		width: "90%",
// 		marginLeft: "auto",
// 		marginRight: "auto",
// 		textAlign: "center",
// 	},
// 	text: {
// 		padding: "20px",
// 		textAlign: "center",
// 		fontSize: "13px",
// 		fontWeight: "lighter",
// 	},
// });

// const IndexMiddleOffice = () => {
// 	const classes = useStyles();
// 	return (
// 		<Box sx={{ pt: 4, display: "flex", justifyContent: "space-between" }}>
// 			<Container>
// 				<HashLink to="/product/all-purpose-wipe#top">
// 					<Box className={classes.imgWrap}>
// 						<img
// 							className={classes.img}
// 							style={{
// 								backgroundSize: "cover",
// 								transition: "all .2s ease-in-out",
// 							}}
// 							alt=""
// 							src="https://images.unsplash.com/photo-1570126618953-d437176e8c79?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1094&q=80"
// 						/>
// 						<button className={classes.btn}>Learn more</button>
// 					</Box>
// 					<Btn variant="contained">Click</Btn>
// 					<Box className={classes.bottom} sx={{ pt: 2 }}>
// 						Heslet Bio Candle
// 					</Box>
// 					<Box className={classes.text}>Kills 99.9% of Germs in 60 Seconds</Box>
// 				</HashLink>
// 			</Container>

// 			<Container>
// 				<HashLink to="/product/all-purpose-spray#top">
// 					<Box className={classes.imgWrap}>
// 						<img
// 							className={classes.img}
// 							style={{
// 								backgroundSize: "cover",
// 								transition: "all .2s ease-in-out",
// 							}}
// 							width="340"
// 							height="330"
// 							alt=""
// 							src="https://images.unsplash.com/photo-1497215641119-bbe6d71ebaae?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=987&q=80"
// 						/>
// 						<button className={classes.btn}>Learn more</button>
// 					</Box>

// 					<Box className={classes.bottom}>Heslet Bio Diffuser</Box>
// 					<Box className={classes.text}>Eliminates Tough Grime at Once</Box>
// 				</HashLink>
// 			</Container>

// 			<Container>
// 				<HashLink to="/product/pet-spray#top">
// 					<Box className={classes.imgWrap}>
// 						<img
// 							className={classes.img}
// 							style={{
// 								backgroundSize: "cover",
// 								transition: "all .2s ease-in-out",
// 							}}
// 							width="340"
// 							height="330"
// 							alt=""
// 							src="https://images.unsplash.com/photo-1522968941782-e27ac665baa3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=988&q=80"
// 						/>
// 						<button className={classes.btn}>Learn more</button>
// 					</Box>

// 					<Box className={classes.bottom}>Bio Room Spray</Box>
// 					<Box className={classes.text}>
// 						Centella Asiatica Extract - Wound & Scar healing
// 					</Box>
// 				</HashLink>
// 			</Container>
// 		</Box>
// 	);
// };

// export default IndexMiddleOffice;

// import React from "react";
// import { Box, Typography } from "@mui/material";
// import { makeStyles } from "@mui/styles";
// const useStyles = makeStyles({
// 	box: {
// 		cursor: "pointer",
// 		boxShadow:
// 			"rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px",
// 	},
// 	imgWrap: {
// 		overflow: "hidden",
// 		display: "inline-block",
// 		width: "330px",
// 		height: "340px",
// 	},
// 	img: {
// 		width: "100%",
// 		height: "100%",
// 		transition: "all .2s ease-in-out",
// 		display: "inline-block",
// 		"&:hover": {
// 			transform: "scale(1.1)",
// 			height: "330px",
// 		},
// 	},
// 	bottom: {
// 		paddingTop: "10px",
// 		paddingBottom: "10px",
// 		borderBottom: "1px solid lightgray",
// 		width: "90%",
// 		marginLeft: "auto",
// 		marginRight: "auto",
// 		textAlign: "center",
// 	},
// 	text: {
// 		padding: "20px",
// 		textAlign: "center",
// 		fontSize: "16px",
// 		fontWeight: "lighter",
// 	},
// });

// const IndexMiddleHome = () => {
// 	const classes = useStyles();
// 	return (
// 		<Box sx={{ pt: 4, display: "flex", justifyContent: "space-between" }}>
// 			<Box
// 				className={classes.box}
// 				sx={{ position: "relative", overflow: "hidden" }}
// 			>
// 				<Box className={classes.imgWrap}>
// 					<img
// 						className={classes.img}
// 						style={{
// 							backgroundSize: "cover",
// 							transition: "all .2s ease-in-out",
// 						}}
// 						alt=""
// 						src="https://images.unsplash.com/photo-1516939884455-1445c8652f83?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=987&q=80"
// 					/>
// 				</Box>

// 				<Box className={classes.bottom}>All Purpose Sanitizing</Box>
// 				<Box className={classes.text}>For wet-weather runs</Box>
// 			</Box>

// 			<Box
// 				className={classes.box}
// 				sx={{ position: "relative", overflow: "hidden" }}
// 			>
// 				<Box className={classes.imgWrap}>
// 					<img
// 						className={classes.img}
// 						style={{
// 							backgroundSize: "cover",
// 							transition: "all .2s ease-in-out",
// 						}}
// 						width="340"
// 						height="330"
// 						alt=""
// 						src="https://images.unsplash.com/photo-1536002583490-9857862b246b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=987&q=80"
// 					/>
// 				</Box>

// 				<Box className={classes.bottom}>All Purpose Sanitizing</Box>
// 				<Box className={classes.text}>For wet-weather runs</Box>
// 			</Box>

// 			<Box
// 				className={classes.box}
// 				sx={{ position: "relative", overflow: "hidden" }}
// 			>
// 				<Box className={classes.imgWrap}>
// 					<img
// 						className={classes.img}
// 						style={{
// 							backgroundSize: "cover",
// 							transition: "all .2s ease-in-out",
// 						}}
// 						width="340"
// 						height="330"
// 						alt=""
// 						src="https://images.unsplash.com/photo-1571782605941-8c8fd0d43df6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=987&q=80"
// 					/>
// 				</Box>

// 				<Box className={classes.bottom}>All Purpose Sanitizing</Box>
// 				<Box className={classes.text}>For wet-weather runs</Box>
// 			</Box>
// 		</Box>
// 	);
// };

// export default IndexMiddleHome;

import React from "react";
import { Box, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { styled } from "@mui/system";
import { HashLink } from "react-router-hash-link";

import { useTranslation } from "react-i18next";
const Btn = styled(Button)`
  position: absolute;
  top: 170px;
  background-color: white;
  color: black;
  box-shadow: none;
  letter-spacing: 0.3em;
  display: none;
  &:hover {
    background-color: #a9a9a9;
  }
  &:focus {
    background-color: green;
  }
`;
const Container = styled(Box)`
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 20px 25px -5px,
    rgba(0, 0, 0, 0.04) 0px 10px 10px -5px;
  position: relative;
  overflow: hidden;
  flex-direction: column;
  align-items: center;
  &:hover {
    btn: {
    }
  }
`;

const useStyles = makeStyles({
  imgWrap: {
    overflow: "hidden",
    display: "inline-block",
    width: "280px",
    height: "290px",
    "&:hover": { backgroundColor: "black" },
    "&:hover $btn": { display: "block" },
  },
  btn: {
    position: "relative",
    top: "-180px",
    left: "+87px",
    backgroundColor: "#212a2f",
    color: "white",
    letterSpacing: "3px",
    textTransform: "uppercase",
    padding: "20px",
    border: "none",
    display: "none",
    cursor: "pointer",
  },
  img: {
    width: "100%",
    height: "100%",
    transition: "all .2s ease-in-out",
    display: "inline-block",
    "&:hover": {
      transform: "scale(1.1)",
      height: "330px",
    },
  },
  bottom: {
    paddingTop: "10px",
    paddingBottom: "10px",
    borderBottom: "1px solid lightgray",
    width: "90%",
    marginLeft: "auto",
    marginRight: "auto",
    textAlign: "center",
  },
  text: {
    padding: "20px",
    textAlign: "center",
    fontSize: "13px",
    fontWeight: "lighter",
  },
});

const IndexMiddleOutdoor = () => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  return (
    <Box sx={{ pt: 4, display: "flex", justifyContent: "space-around" }}>
      <Container>
        <HashLink to="/product/all-purpose-wipe#top">
          <Box className={classes.imgWrap}>
            <img
              className={classes.img}
              style={{
                backgroundSize: "cover",
                transition: "all .2s ease-in-out",
              }}
              alt=""
              src="https://images.unsplash.com/photo-1622372738946-62e02505feb3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1132&q=80"
            />
            <button className={classes.btn}>{t("learn_more")}</button>
          </Box>
          <Btn variant="contained">Click</Btn>
          <Box className={classes.bottom} sx={{ pt: 2 }}>
            {t("index_middle_kitchen1")}
          </Box>
          <Box className={classes.text}>{t("index_middle_kitchen1_exp")}</Box>
        </HashLink>
      </Container>

      <Container>
        <HashLink to="/product/all-purpose-spray#top">
          <Box className={classes.imgWrap}>
            <img
              className={classes.img}
              style={{
                backgroundSize: "cover",
                transition: "all .2s ease-in-out",
              }}
              width="340"
              height="330"
              alt=""
              src="https://images.unsplash.com/photo-1565538810643-b5bdb714032a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80"
            />
            <button className={classes.btn}>{t("learn_more")}</button>
          </Box>

          <Box className={classes.bottom}>{t("index_middle_kitchen2")}</Box>
          <Box className={classes.text}>{t("index_middle_kitchen2_exp")}</Box>
        </HashLink>
      </Container>

      <Container>
        <HashLink to="/product/pet-spray#top">
          <Box className={classes.imgWrap}>
            <img
              className={classes.img}
              style={{
                backgroundSize: "cover",
                transition: "all .2s ease-in-out",
              }}
              width="340"
              height="330"
              alt=""
              src="https://images.unsplash.com/photo-1556037843-347ddff9f4b0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80"
            />
            <button className={classes.btn}>{t("learn_more")}</button>
          </Box>

          <Box className={classes.bottom}>{t("index_middle_kitchen3")}</Box>
          <Box className={classes.text}>{t("index_middle_kitchen3_exp")}</Box>
        </HashLink>
      </Container>
    </Box>
  );
};

export default IndexMiddleOutdoor;
